module.exports = __webpack_public_path__ + "img/friends-welcome-header.bc0de8a2.png";